import { useContext, useEffect, useMemo, useState } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";

import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetAllNodes } from "../api/getAllNodes";


// All your logic is here
export const useNodesDataViewLogic = () => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: [],});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetNode[]>([]);
  const getAllNodesQuery = useGetAllNodes({data: activeFilters as INodeSearchForm});
  const { t } = useTranslation();

  const loadingDone = [getAllNodesQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getAllNodesQuery].filter(({ isError }) =>isError ? true : false);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getAllNodesQuery.data ? getAllNodesQuery.data : [];

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "ID",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "description",
      columnDisplayName: "Περιγραφή",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "hostName",
      columnDisplayName: "Hostname",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "deleted",
      columnDisplayName: "Διαγραμμένο",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "Boolean",
    }
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Κόμβου");
        break;
      case "edit":
        title = t("Προβολή Κόμβου");
        break;
      case "delete":
        title = t("Διαγραφή Κόμβου");
        break;
      default:
        break;
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    console.log(
      "selectedRows",
      selectedRows,
      "selectedRowOfTable",
      selectedRowsOfTable,
      "selectedRowOfTable[0]",
      selectedRowsOfTable[0]
    );
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };



  useEffect(() => {
    setSelectedRowsOfTable([]);
    getAllNodesQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
  };
};
